import { useState, useEffect } from "react";
import { AdvancedMarker, useMap } from "@vis.gl/react-google-maps";

import { Circle } from '../../../../components/Map/components/Circle';
import { MapContent } from "../../../../components/Map";

const circleOptions = {
  strokeColor: "#004b93",
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillColor: "#004b93",
  fillOpacity: 0.15,
  clickable: false,
  draggable: false,
  editable: false,
  zIndex: 1,
};

const DEFAULT_GEOFENCE_SIZE = 500;

const CustomMarkers = ({ initialPosition, geoFenceSize, onDragEnd }) => {
  const map = useMap();

  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState(initialPosition);

  useEffect(() => {
    if (initialPosition) {
      setPosition(initialPosition);
      map?.panTo(initialPosition);
    }
  }, [initialPosition, map]);

  const onDragMarker = () => setIsDragging(true);

  const handleOnDragEnd = (e) => {
    setPosition({ lat: e.latLng.lat(), lng: e.latLng.lng() });
    setIsDragging(false);

    map.panTo(e.latLng);
    onDragEnd(e);
  };

  return (
    <>
      <Circle
        visible={!isDragging}
        key={"keyCircleMaps"}
        center={position}
        options={circleOptions}
        radius={geoFenceSize}
      />
      <AdvancedMarker
        title="marker"
        position={position}
        onDrag={onDragMarker}
        onDragEnd={handleOnDragEnd}
        draggable
      />
    </>
  );
};

const MapContentWithCoordinates = ({
  coordinates,
  zoom,
  geoFenceSize,
  onDragMarkerEnd,
}) => {
  const geoFenceSizeNumber =
    geoFenceSize === "" || geoFenceSize === undefined || geoFenceSize === null
      ? DEFAULT_GEOFENCE_SIZE
      : geoFenceSize;

  const onDragEnd = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    onDragMarkerEnd({ lat, lng });
  };

  return (
    <MapContent centerCoordinate={coordinates} zoom={zoom} key={"one-map"}>
      <CustomMarkers
        initialPosition={coordinates}
        geoFenceSize={geoFenceSizeNumber}
        onDragEnd={onDragEnd}
      />
    </MapContent>
  );
};

export default MapContentWithCoordinates;
